export type AvatarTone = {
  backgroundSaturation: number;
  backgroundLightness: number;
  foregroundSaturation: number;
  foregroundLightness: number;
};

// Keep the same hue for a person in both themes; only the contrast changes.
const avatarHues = [
  215,
  164,
  36,
  329,
  182,
  276,
  55,
  9,
  201,
  126,
  306,
  248,
  76,
  351,
  150,
  292,
] as const;

export const avatarHueFor = (userId?: string, name?: string) => {
  const id = String(userId || '')
    .trim()
    .toLowerCase();
  const normalizedName = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  const identity =
    id && id !== 'undefined' && id !== 'null' ? id : normalizedName;
  if (!identity) return undefined;

  let hash = 2166136261;
  for (let index = 0; index < identity.length; index += 1) {
    hash = Math.imul(hash ^ identity.charCodeAt(index), 16777619);
  }
  return avatarHues[(hash >>> 0) % avatarHues.length];
};

export const avatarBackgroundColor = (hue: number, tone: AvatarTone) =>
  `hsl(${hue} ${tone.backgroundSaturation}% ${tone.backgroundLightness}%)`;

export const avatarForegroundColor = (hue: number, tone: AvatarTone) =>
  `hsl(${hue} ${tone.foregroundSaturation}% ${tone.foregroundLightness}%)`;
